module.exports = __webpack_public_path__ + "img/Christmas-coupon-1.fd2c1fa.png";